module.exports = __webpack_public_path__ + "img/calendar-today.516bb5e3.svg";